// ==========================================
// Collapsed bubble (4a)
// ==========================================
// Where BB lives when you're not talking to him: a 56px puck with the XP ring around
// it, draggable to any corner. Tap or Alt+Space wakes the panel, which grows out of
// this bubble's corner (4c).
// ==========================================

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { BbState, GrowthStage } from '../models/buddy.types';
import { ACCENT_HEX, TRACK_HEX } from '../models/buddy.constants';

/** Circumference of the r=28 ring, used to drive stroke-dashoffset. */
const RING_CIRCUMFERENCE = 2 * Math.PI * 28;

@Component({
  selector: 'app-buddy-bubble',
  standalone: false,
  templateUrl: './buddy-bubble.component.html',
  styleUrls: ['./buddy-bubble.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuddyBubbleComponent {
  @Input() bbState: BbState = 'dozing';
  @Input() stage: GrowthStage = 'scout';
  @Input() xpPct = 0;
  /** Something is waiting — pulses the ring once per cycle. */
  @Input() attention = false;
  @Input() dragging = false;

  @Output() opened = new EventEmitter<void>();
  @Output() dragStarted = new EventEmitter<PointerEvent>();

  readonly circumference = RING_CIRCUMFERENCE;
  /** Brand orange fill on a gray-200 track — the collapsed form of the XP rail. */
  readonly xpColor = ACCENT_HEX.xp;
  readonly trackColor = TRACK_HEX;

  get dashOffset(): number {
    const pct = Math.max(0, Math.min(100, this.xpPct));
    return RING_CIRCUMFERENCE * (1 - pct / 100);
  }

  onPointerDown(event: PointerEvent): void {
    this.dragStarted.emit(event);
  }

  onClick(): void {
    // Suppressed while a drag is in flight so dropping the bubble doesn't open it.
    if (!this.dragging) {
      this.opened.emit();
    }
  }
}
